module.exports = __webpack_public_path__ + "static/media/logoGetViral.b017d5fb.png";